// STUB (issue #241): fill in the official Startline profile URLs; entries with url null are not rendered.
export type SocialKey = 'linkedin' | 'instagram' | 'facebook' | 'strava'

export interface SocialLink {
  key: SocialKey
  url: string | null
}

export const SOCIAL_LINKS: ReadonlyArray<SocialLink> = [
  { key: 'linkedin', url: null },
  { key: 'instagram', url: null },
  { key: 'facebook', url: null },
  { key: 'strava', url: null },
]
